import {FC} from "react";

export interface CurrencyProps {
    currencyCode: string;
    locale?: string;
    amount: number;
    className: string;
}

const Currency: FC<CurrencyProps> = ({currencyCode, locale, amount, className}) => {
    const getCurrencySymbol = (currencyCode: string, locale = 'en-US') => {
        try {
            const formatter = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            // Use formatToParts to extract the currency symbol part
            const parts = formatter.formatToParts(0);
            const currencyPart = parts.find(part => part.type === 'currency');
            return currencyPart ? currencyPart.value : ''; // Return the symbol or empty string
        } catch (error) {
            console.error("Error getting currency symbol:", error);
            return ''; // Handle potential errors gracefully
        }
    };

    const symbol = getCurrencySymbol(currencyCode, locale);
    return (
        <div className={className}>
            {symbol && <span>{symbol}{amount}</span>}
        </div>
    );
}

export default Currency;